import { useMemo } from 'react';
import { MemberType } from 'api/models';
import { Option } from 'components/atoms/select';
import { useTranslate } from 'hooks/use-translation';
import { useAccountDataQuery } from 'queries/account';
import {
  AccountPermissionSetType,
  PermissionSet,
} from 'stores/permission-sets';
import {
  translationKeyForPartnerMemberPermissionLabel,
  translationKeyForPartnerMemberPermissionDescription,
} from '../../utils';

interface Result {
  permissionSets: PermissionSet[];
  permissionOptions: Option[];
}
export const usePermissionOptions = (): Result => {
  const translate = useTranslate();
  const { data: accountData } = useAccountDataQuery();
  const permissionList = useMemo(
    () =>
      (accountData?.permissionSetList ?? [])
        .filter(
          ({ permissionSetSpecificTo, permissionSetType }) =>
            permissionSetSpecificTo === MemberType.Partner &&
            permissionSetType !== AccountPermissionSetType.PartnerCollaborator, // specific for project
        )
        .map(({ permissionSetType }) => ({
          label: translate(
            translationKeyForPartnerMemberPermissionLabel(
              permissionSetType as AccountPermissionSetType,
            ),
          ),
          value: permissionSetType,
          description: translate(
            translationKeyForPartnerMemberPermissionDescription(
              permissionSetType as AccountPermissionSetType,
            ),
          ),
        })),
    [accountData?.permissionSetList, translate],
  );

  return {
    permissionSets: accountData?.permissionSetList ?? [],
    permissionOptions: permissionList,
  };
};
